import { FormikErrors } from 'formik';
import convertToYup from 'json-schema-yup-transformer';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormValues, IForm } from 'app/pages/Registration/utils';
import { StyledButton } from 'app/components/StyledStep';
import { StepFooterProps } from 'app/pages/Registration/interfaces';

const useDisabled = ({
  validation,
  errors,
  values,
  index,
}: {
  validation: ReturnType<typeof convertToYup>;
  index: number;
  errors?: FormikErrors<Record<string, FormValues>>;
  values: IForm;
}) => {
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    (async () => {
      if (errors === undefined) {
        const touched = (await validation?.isValid(values)) ?? false;
        setDisabled(!touched);
      } else {
        setDisabled(true);
      }
    })();
  }, [validation, errors, index, values]);
  return disabled;
};

const NextStep: React.FC<StepFooterProps> = ({
  handleNextStep,
  isSubmit,
  errors,
  values,
  index,
  isSubmitted,
  validation,
}) => {
  const { t } = useTranslation();
  const disabled = useDisabled({
    errors,
    values,
    index,
    validation,
  });

  return (
    <StyledButton
      className="form-field__max-width"
      fullWidth
      disabled={disabled || isSubmitted}
      onClick={handleNextStep}
      variant="contained"
      color="primary"
      type="submit"
    >
      {isSubmit ? t('registration.submit') : t('registration.next')}
    </StyledButton>
  );
};

export default NextStep;
